import * as OrderTexts from '../../../../../../../../intl'
import { form } from '../../../../../formState'
import { Props } from '../../../typings'

export function Email(props: Props) {
  const { orderStepType, notificationBehavior, initialValues, validateEmail } = props

  const fieldNameEmail = `${orderStepType}.email` as 'pickup.email' | 'delivery.email'

  form.useAddFieldValidation<typeof fieldNameEmail>(fieldNameEmail, async (field, _formApi) => {
    const email = field.value

    if (notificationBehavior !== 'NO_NOTIFICATIONS') {
      const emailFieldPristine = email === initialValues.orderStep.email
      const skipEmailValidation = emailFieldPristine

      const emailValid = skipEmailValidation || !email ? true : await validateEmail(email)

      if (!emailValid) {
        return OrderTexts.getValidationErrorEmailText()
      }
    }
  })

  return (
    <form.TextField
      name={`${orderStepType}.email`}
      label={OrderTexts.getFieldLabelEmailText()}
      testId="email"
      validateOn="blur"
    />
  )
}
